<template>
  <div
    class="field"
    v-diff-field="diff"
    :class="{ warning: value && !looksValid, success: value && looksValid }"
  >
    <label :for="_uid + '-regexField'">{{ labelText }}</label>
    <div
      class="ui"
      :class="[size, actions && actions.length > 0 ? 'left icon action input' : 'right icon input']"
    >
      <i class="ui lightning icon" />
      <input
        class="monospaced"
        :id="_uid + '-regexField'"
        :class="inputFieldClass"
        :title="latestError || $t('REGEX')"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        @click="$emit('click')"
        @input="onInput"
        type="text"
      />
      <button
        class="ui icon button"
        :class="[size, a.color]"
        v-for="a in actions"
        :key="a.name"
        @click.stop.prevent="emitAction(a)"
      >
        <i class="ui icon" :class="a.icon" />
      </button>
    </div>
  </div>
</template>

<script>
// @flow
export default {
  name: 'regex-field',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    inputFieldClass: {
      type: Object,
      default: () => {}
    },
    labelText: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    diff: {
      type: Object,
      default: () => {}
    },
    size: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      latestError: '',
      validateDebounced: _.throttle(() => this.validate(), 200, { leading: false })
    }
  },
  computed: {
    looksValid() {
      return !this.latestError
    }
  },
  methods: {
    onInput(event) {
      this.validateDebounced()
      this.$emit('input', event.target.value)
    },
    emitAction(a) {
      this.$emit('action', a)
    },
    validate() {
      try {
        new RegExp(this.value)
        this.latestError = ''
      } catch (error) {
        this.latestError = error.message
      }
    }
  }
}
//
</script>
